module.exports = __webpack_public_path__ + "static/media/starter.f492e2dd.jpg";